import gql from 'graphql-tag'
import {IDS} from "../../Constants/IDS";

export const CREATE_UPDATE_TRIP_ORG_STOCK = gql`
    mutation ($trips:[VehicleTrip_insert_input!]!, $trip_on_conflict_rule: VehicleTrip_on_conflict!, $tripStock:[VehicleTripStock_insert_input!]!, $tripStock_on_conflict_rule: VehicleTripStock_on_conflict!, $tripDestinations:[TripDestinations_insert_input!]!, $tripDestinations_on_conflict_rule: TripDestinations_on_conflict!, $orgStock:[OrganizationStock_insert_input!]!, $orgStock_on_conflict_rule: OrganizationStock_on_conflict!) {
        insert_VehicleTrip(objects: $trips, on_conflict: $trip_on_conflict_rule){
            returning{
                id
            }
        },
        insert_VehicleTripStock(objects: $tripStock, on_conflict: $tripStock_on_conflict_rule){
            returning{
                id
            }
        },
        insert_TripDestinations(objects: $tripDestinations, on_conflict: $tripDestinations_on_conflict_rule){
            returning{
                id
            }
        },
        insert_OrganizationStock(objects: $orgStock, on_conflict: $orgStock_on_conflict_rule){
            returning{
                id
            }
        }
    }`

export const CREATE_UPDATE_OPENING_TRIP_ORG_STOCK = gql`
    mutation ($previousTripId:uuid!,$trips:[VehicleTrip_insert_input!]!, $trip_on_conflict_rule: VehicleTrip_on_conflict!, $tripStock:[VehicleTripStock_insert_input!]!, $tripStock_on_conflict_rule: VehicleTripStock_on_conflict!, $tripDestinations:[TripDestinations_insert_input!]!, $tripDestinations_on_conflict_rule: TripDestinations_on_conflict!, $orgStock:[OrganizationStock_insert_input!]!, $orgStock_on_conflict_rule: OrganizationStock_on_conflict!) {
        insert_VehicleTrip(objects: $trips, on_conflict: $trip_on_conflict_rule){
            returning{
                id
            }
        },
        insert_VehicleTripStock(objects: $tripStock, on_conflict: $tripStock_on_conflict_rule){
            returning{
                id
            }
        },
        insert_TripDestinations(objects: $tripDestinations, on_conflict: $tripDestinations_on_conflict_rule){
            returning{
                id
            }
        },
        insert_OrganizationStock(objects: $orgStock, on_conflict: $orgStock_on_conflict_rule){
            returning{
                id
            }
        },
        update_VehicleTrip(where: {id: {_eq: $previousTripId}}, _set:{statusId: "${IDS.TripStatus.Unloaded}"}){
            returning{
                id
            }
        }
    }`

export const UNLOAD_TRIP_STOCK = gql`
    mutation ($orgStockId:uuid!, $stockQty:Int!, $vehicleTripStockId:uuid!, $unloadedQty:Int!){
        update_OrganizationStock(where: {id:{_eq:$orgStockId}}, _set:{quantity:$stockQty}){
            returning{
                id
            }
        },
        update_VehicleTripStock(where: {id:{_eq:$vehicleTripStockId}}, _set:{currentQty:0, unloadedQty:$unloadedQty}){
            returning{
                id
            }
        }
    }`

export const UPDATE_TRIP_CURRENT_STOCK = gql`
    mutation($tripId:uuid!,$currentQty:Int!){
        update_VehicleTripStock(where: {vehicleTripId: {_eq: $tripId}}, _set:{currentQty: $currentQty}){
            returning{
                id
            }
        }
    }
`

export const UPDATE_TRIP_STATUS = gql`
    mutation($tripId:uuid!,$status:uuid!){
        update_VehicleTrip(where: {id: {_eq: $tripId}}, _set:{statusId: $status}){
            returning{
                id
            }
        }
    }`
